// font-family tokens from master-design-system.json → typography.EPIC.font-family
// brand=Poppins  sans=Geist  mono=Geist Mono
export type FontFamilyToken = "brand" | "sans" | "mono"

export const fontFamilyClasses: Record<FontFamilyToken, string> = {
  brand: "font-brand",
  sans:  "font-sans",
  mono:  "font-mono",
}
